import { CollectionHelpers } from 'src/helpers/CollectionHelpers';
import useSWR from 'swr';

import { DistributorPriceService } from 'services/DistributorPriceService';

const useDistributorPrice = (componentId?: string | null) => {
    const swr = useSWR(
        componentId ? DistributorPriceService.swr.product(componentId) : null,
        () => DistributorPriceService.findForProduct(componentId!),
        {
            revalidateOnFocus: true,
            keepPreviousData: true,
        },
    );

    const data = swr.data;
    const shouldResetPrice = data && CollectionHelpers.id(data.component) !== componentId;
    const distributorPrice = shouldResetPrice ? undefined : data;

    return {
        ...swr,
        distributorPrice,
    };
};

export { useDistributorPrice };
